import React from "react";
import { Box, Chip, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const toneStyles = {
  teal: { bgcolor: "#e1f5ee", color: "#0f6e56" },
  amber: { bgcolor: "#faeeda", color: "#b5790f" },
  coral: { bgcolor: "#faece7", color: "#d85a30" },
};

const toneForAction = (action = "") => {
  const a = action.toLowerCase();
  if (a.includes("reject")) return "coral";
  if (a.includes("accept") || a.includes("complete") || a.includes("create")) return "teal";
  return "amber";
};

const RecentActivityTable = ({ items }) => {
  if (!items.length) {
    return (
      <Typography sx={{ fontSize: 13, color: "text.secondary", py: 2 }}>
        No recent activity.
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableBody>
        {items.map((row, idx) => (
          <TableRow key={idx} sx={{ "&:last-child td": { borderBottom: "none" } }}>
            <TableCell sx={{ fontSize: 13 }}>
              <Box component="span">
                <Typography component="b" sx={{ fontWeight: 700 }}>
                  {row.actor}
                </Typography>{" "}
                {row.description}
              </Box>
            </TableCell>
            <TableCell align="right" sx={{ width: 90 }}>
              <Chip
                label={row.createdAt ? dayjs(row.createdAt).fromNow() : "—"}
                size="small"
                sx={{
                  fontSize: 11,
                  fontWeight: 600,
                  height: 22,
                  ...toneStyles[toneForAction(row.action)],
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default RecentActivityTable;
